import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import About from "./pages/About/About";
import BlogSections from "./pages/BlogSections/BlogSections";
import Blogs from "./pages/Blogs/Blogs";
import BlogDetails from "./pages/Blogs/BlogDetails";
import ContactUs from "./pages/ContactUs/ContactUs";
import Service from './pages/Service/Service';
import ListYourProperty from './pages/ListYourProperty/ListYourProperty';
import SearchResults from './pages/SearchResults/SearchResults';
import PropertyDetails from './pages/PropertyDetails/PropertyDetails';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
import "./App.css";
import Locations from './pages/Locations/Locations';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import FAQ from './pages/FAQ/FAQ';
import Notfound from './pages/notFound/notfound';
import { basename } from './configiration/config';
import { getScripts } from "./Api/commonApis";
import { useEffect } from 'react';

function App() {
  ReactGA.initialize('G-TLTTZ05P9E');
  ReactGA.pageview(window.location.pathname + window.location.search);
  const { i18n } = useTranslation();
  
  // get scripts
  useEffect(() => {
    getScripts('script').then((res) => {
      let scripts = res.data.data
      scripts.map((script) => {
        document.head.innerHTML += script.script;
        return true;
      })
    })
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`${i18n.language === 'en' ? 'englishWrapper' : 'arabicWrapper'} App`}>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path={`${basename}`} element={<Home />} />
          <Route path={`${basename}/about`} element={<About />} />
          <Route path={`${basename}/blogs`} element={<BlogSections />} />
          <Route path={`${basename}/blogs/:slug`} element={<Blogs />} />
          <Route path={`${basename}/blogs/:section/:slug`} element={<BlogDetails />} />
          <Route path={`${basename}/contact-us`} element={<ContactUs />} />
          <Route path={`${basename}/our-services/:slug`} element={<Service />} />
          <Route path={`${basename}/list-your-property`} element={<ListYourProperty />} />
          <Route path={`${basename}/search-results`} element={<SearchResults />} />
          <Route path={`${basename}/areas/:slug`} element={<Locations />} />
          <Route path={`${basename}/property-details/:slug`} element={<PropertyDetails />} />
          <Route path={`${basename}/faq`} element={<FAQ />} />
          <Route path={`${basename}/terms-and-conditions`} element={<TermsAndConditions />} />
          <Route path={`${basename}/privacy-policy`} element={<PrivacyPolicy />} />
          <Route path={`${basename}/*`} element={<Notfound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
